var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$judgeServerHostname()==1)?_c('LoginMongolia'):(_vm.$judgeServerHostname()==2)?_c('LoginQiye'):(_vm.$judgeServerHostname()==3)?_c('HRLogin'):_c('LoginCommon')}
var staticRenderFns = []

export { render, staticRenderFns }